import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {SocialPostNames} from "../../../../types/socialTypes";

export interface InstagramFormState{
    caption: string
}

interface InstagramFormStateProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    onFieldBlur?: (field: string, value: string | boolean) => void;
    defaultFormState: InstagramFormState
    selectedPostType: string
    disableCompilationFields?: boolean
}

const InstagramForm: React.FC<InstagramFormStateProps> = ({
                                                              onFieldChange,
                                                              onFieldBlur, // Destrutturiamo la nuova prop
                                                              defaultFormState,
                                                              selectedPostType,
                                                              disableCompilationFields = false
                                                          }) => {

    const handleBlur = (field: string, value: string | boolean) => {
        if (onFieldBlur) {
            onFieldBlur(field, value);
        }
    };

    return (
        selectedPostType !== SocialPostNames.story ? (
            <Grid container spacing={2}>
                <Grid size={12}>
                    <TextField
                        multiline
                        minRows={6}
                        placeholder={'Type post caption'}
                        label={'Caption'}
                        value={defaultFormState.caption}
                        onChange={(e) => onFieldChange('caption', e.target.value)}
                        onBlur={(e) => handleBlur('caption', e.target.value)}
                        fullWidth
                        sx={{ height: '100%', display: 'flex' }}
                        disabled={disableCompilationFields}
                    />
                </Grid>
            </Grid>
        ) : null
    )
}

export default InstagramForm;